// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors

import {Log} from '@probe.gl/log';

/** Global log instance */
export const log: Log = new Log({id: 'luma.gl'});
